<arm-dialog (onCancel)="cancel()"
            (onSubmit)="submit()"
            [disabled]="true"
            [title]="'CERTIFICATE'">

  <div class="parsed-certificate">
    <mat-form-field class="fullWidth">
      <mat-label>Certificate</mat-label>
      <textarea matInput cdkTextareaAutosize [(ngModel)]="data.parsedCertificate" name="parsedCertificate" cdkAutosizeMinRows="6" [disabled]="true"></textarea>
    </mat-form-field>
  </div>

  <div class="pem-certificate">
    <div class="pem-actions">
      <span><i class="fa fa-download download" matTooltip="Download" (click)="downloadPem()"></i></span>
      <span><i class="fa fa-copy copy" matTooltip="Copy" [cdkCopyToClipboard]="data.certificate"></i></span>
    </div>
    <mat-form-field class="fullWidth">
      <mat-label (click)="downloadPem()">PEM</mat-label>
      <textarea matInput cdkTextareaAutosize [(ngModel)]="data.certificate" name="certificate" cdkAutosizeMinRows="10" cdkAutosizeMaxRows="20" [disabled]="true"></textarea>
    </mat-form-field>
  </div>

</arm-dialog>
